import axios from 'axios';
// import _ from 'underscore';
// import { acConSizeChange } from './acConSizeChange.js'
export function acAxiosRequest(val) {
    return function (dispatch) {
        // console.log('acAxiosRequest', val);
        if (val.loading === true) {
            dispatch({ type: 'LOADING', payload: val.reducer })
        }
        var value = ''
        if (val.value) { value = val.value }
        let newParam = "&" + val.newParam
        axios({
            method: 'GET',
            url: '' + val.ruta + '' + val.request + '?' + value + newParam,
        }).then(function (response) {

            if ((response.data.status) && (response.data.status === 'redirect')) { dispatch({ type: 'ERROR', payload: { conErr: true, val: val.error } }) }
            if ((response.data.status) && (response.data.status === 'error')) { dispatch({ type: 'ERROR', payload: { conErr: true, val: val.error } }) }

            // Can't access object property, even though it exists. Returns undefined
            // if (val.reducer === "NR_FAVORITE_MIDDLE") {
            //     if ((response.data.status) && (response.data.status === 'success')) {
            //         setTimeout(function () {
            //             dispatch({ type: val.reducer, payload: response.data })
            //         }, 1000);
            //     } else if ((response.data.status) && (response.data.status === 'popup')) {
            //         setTimeout(function () {
            //             dispatch({ type: val.reducer, payload: response.data })
            //         }, 1000);
            //     }
            // }

            if (val.extra) {
                dispatch({ type: val.reducer, payload: { extra: val.extra, response: response.data } })
            } else {
                dispatch({ type: val.reducer, payload: response.data })
            }

            if (val.reducer2) {
                // console.log('indyyyy', response.data, val.extra, val.reducer2);
                if (val.extra) {
                    dispatch({
                        type: val.reducer2, payload: { extra: val.extra, response: response.data }
                    })
                } else {
                    dispatch({ type: val.reducer2, payload: response.data })
                }
            }
            if (val.loading === true) {
                dispatch({ type: 'LOADING', payload: false })
            }
        }).catch(function (error) {
            dispatch({ type: 'ERROR', payload: { conErr: true, val: val.error } })
            console.log('acAxiosRequest-error', val.reducer, error);
        });
    }
}

